const BEST_BUY_RGM_REASON_MAPS = {
  FMS: {
    '01': {
      title: 'Core Return',
      detail: '',
    },
    '02': {
      title: 'Defective Part',
      detail: 'Part received is DOA',
    },
    '03': {
      title: 'Excess Quantity',
      detail: 'Vendor shipped qty > than qty ordered',
    },
    '04': {
      title: 'Not Needed Part',
      detail: 'Part ordered and returned as new',
    },
    '05': {
      title: 'Salvage',
      detail: '',
    },
    '06': {
      title: 'Wrong Part',
      detail: 'Received a different part than was ordered',
    },
    '07': {
      title: 'Concealed Damage',
      detail: 'Packaging intact, part is damaged but not due to carrier',
    },
    '08': {
      title: 'Send Back',
      detail: 'Aged parts from stock returned for credit',
    },
    '09': {
      title: 'Shipping Damage',
      detail: '',
    },
    11: {
      title: 'Rapid Exchange',
      detail: '',
    },
  },
  MRP: {
    '01': {
      title: 'Core',
      detail: '',
    },
    '02': {
      title: 'DOA',
      detail: '',
    },
    '03': {
      title: 'Excess Qty',
      detail: '',
    },
    '04': {
      title: 'Not Needed',
      detail: '',
    },
    '05': {
      title: 'Wrong Part',
      detail: '',
    },
    '06': {
      title: 'Concealed Damage',
      detail: '',
    },
    '07': {
      title: 'Send Back',
      detail: '',
    },
    '08': {
      title: 'Ship Damage',
      detail: '',
    },
  },
};

export function getBestBuyRgmReasonFamily(rgmNumber = '') {
  const prefix = String(rgmNumber || '').trim().toUpperCase().slice(0, 3);

  if (prefix === 'RSH') {
    return 'MRP';
  }

  if (prefix === 'RNP') {
    return 'FMS';
  }

  return 'FMS';
}

export function getBestBuyRgmReasonDetails(code, rgmNumber = '') {
  const normalizedCode = String(code || '').trim() || 'Unknown';
  const family = getBestBuyRgmReasonFamily(rgmNumber);
  const familyMap = BEST_BUY_RGM_REASON_MAPS[family] || BEST_BUY_RGM_REASON_MAPS.FMS;
  const match = familyMap[normalizedCode];

  if (match) {
    return {
      ...match,
      code: normalizedCode,
      family,
      key: `${family}:${normalizedCode}`,
    };
  }

  return {
    title: normalizedCode,
    detail: '',
    code: normalizedCode,
    family,
    key: `${family}:${normalizedCode}`,
  };
}
